import React from 'react';
import { observer } from 'mobx-react';
import { isSome, renderIf, translate, findUserAction } from 'core/utils';
import moment from 'moment';
import _ from 'lodash';

function HistoryLogTemplate({ listStore, order }) {
	return (
		<React.Fragment>
			{isSome(listStore.response) &&
			isSome(listStore.response.item) &&
			listStore.response.item.length > 0 &&
			listStore.response.item.some(element => isSome(element.changed) && element.changed.length > 0) ? (
				_.map(listStore.response.item, (item, index) => {
					var localCreationDate = moment
						.utc(item.dateCreated)
						.toDate()
						.toLocaleString();

					if (isSome(item.changed) && item.changed.length > 0) {
						return (
							<div key={index} className="activity-log__card spc--bottom--sml">
								<div className="activity-log__card__header">
									<h4>
										{
											moment(localCreationDate)
												.format('MMMM Do YYYY, h:mm a')
												.split(',')[0]
										}
										<span className="type--tny spc--left--tny spc--right--tny"> &#8226; </span>
										{moment
											.utc(item.dateCreated)
											.toDate()
											.toLocaleString()
											.split(',')
											.pop()}
									</h4>
									<label className="type--sml type--color--grey-5">{findUserAction(item.userAction)}</label>
								</div>
								<div className="activity-log__seller">
									<span className="fas fa-user-alt type--tny spc--right--tny"></span>
									<span>{item.user != null ? item.user.displayName.split('-')[0] : ''}</span>
								</div>
								<div className="activity-log__list__fake"></div>
								<ul className="activity-log__list">
									{isSome(item.changed) &&
										item.changed.length > 0 &&
										_.map(item.changed, (changedItem, index) => {
											if (
												(changedItem.name == 'Assigned Timestamp' ||
													changedItem.name == 'Order date' ||
													changedItem.name == 'Payment date') &&
												moment(changedItem.newValue, ['DD.MM.YYYY. hh:mm:ss', 'MM/DD/YYYY hh:mm:ss a']).isValid()
											) {
												const date = moment
													.utc(changedItem.newValue, ['DD.MM.YYYY. hh:mm:ss', 'MM/DD/YYYY hh:mm:ss a'])
													.format();
												changedItem.newValue = moment
													.utc(date)
													.toDate()
													.toLocaleString();
												if (
													changedItem.name == 'Assigned Timestamp' &&
													moment(changedItem.initialValue, ['DD.MM.YYYY. hh:mm:ss', 'MM/DD/YYYY hh:mm:ss a']).isValid()
												) {
													const date = moment
														.utc(changedItem.initialValue, ['DD.MM.YYYY. hh:mm:ss', 'MM/DD/YYYY hh:mm:ss a'])
														.format();
													changedItem.initialValue = moment
														.utc(date)
														.toDate()
														.toLocaleString();
												}
											} else if (
												(changedItem.name == 'Ship by date' || changedItem.name == 'Deliver by date') &&
												moment(changedItem.newValue, ['DD.MM.YYYY. hh:mm:ss', 'MM/DD/YYYY hh:mm:ss a']).isValid()
											) {
												var time = moment.duration(order.timezoneOffset);
												var newDate = moment(changedItem.newValue);
												newDate.subtract(time);
												newDate = newDate.format('MM/DD/YYYY hh:mm:ss a');
												var date = moment(newDate, ['DD.MM.YYYY. hh:mm:ss', 'MM/DD/YYYY hh:mm:ss a']).format();

												changedItem.newValue = moment(date).format('MM/DD/YYYY');
											}
											return (
												<li key={index} className="activity-log__list__item">
													Changed <span className="type--wgt--bold">{changedItem.name}</span>
													{changedItem.initialValue === '' ? '' : ' from '}
													{renderIf(changedItem.initialValue != '')(
														<span className="activity-log__badge activity-log__badge--old">
															{changedItem.initialValue}
														</span>
													)}{' '}
													to{' '}
													<span className="activity-log__badge activity-log__badge--new">
														{changedItem.newValue != '' ? changedItem.newValue : 'None'}
													</span>
												</li>
											);
										})}
								</ul>
							</div>
						);
					}
				})
			) : isSome(listStore.response) &&
			  isSome(listStore.response.item) &&
			  (listStore.response.item.length == 0 ||
					listStore.response.item.every(
						element => !isSome(element.changed) || (isSome(element.changed) && element.changed.length === 0)
					)) ? (
				<p className="flex--primary flex--align--h--center padd--top--sml">{translate('LISTEMPTY.HISTORYLOG')}</p>
			) : (
				<div className="pos--rel h--60">
					<div className="spinner spinner--g"></div>
				</div>
			)}
		</React.Fragment>
	);
}

export default observer(HistoryLogTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/components/HistoryLogTemplate.jsx